/*!

=========================================================
* Paper Dashboard React - v1.3.0
=========================================================

* Product Page: https://www.creative-tim.com/product/paper-dashboard-react
* Copyright 2021 Creative Tim (https://www.creative-tim.com)

* Licensed under MIT (https://github.com/creativetimofficial/paper-dashboard-react/blob/main/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React, {useState, useEffect } from "react";
import winImg from "assets/img/win.png";
import loseImg from "assets/img/lose.png";
import { useHistory } from 'react-router-dom';
// reactstrap components
import NotificationAlert from "react-notification-alert";
import Modal from 'react-modal';
import {  
  Card,
  CardHeader,
  CardBody,
  CardTitle,
  Form,
  Row,
  Col,
} from "reactstrap";


let axios = require('axios');
let URL_API = "https://xs458763.xsrv.jp/api/";
let session;
let notificationAlert;
let se;

const customStyles = {
  content: {
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
    padding:'0.25rem',
    width:'85%',
    borderRadius:'15px',
    fontWeight:'bold'
  },
};

window.mobileCheck = function() {
  let check = false;
  (function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4))) check = true;})(navigator.userAgent||navigator.vendor||window.opera);
  return check;
};
var aTimeout = null;

function Tables() {
  
  notificationAlert = React.useRef();  
  
  const history = useHistory();

  const [a_proposer, s_setProposerData] = useState([]);
  const [modalIsOpen, setIsOpen]    = useState(false);
  const [selTmp, setSelTmp] = useState(null);
  //const [a_opponent, s_setOpponentData] = useState([]);

  const getViewpageUrl = (tmp) => {
    window.sessionStorage.setItem('selTables', JSON.stringify(tmp));
    history.push('../sub/tablesedit');
  }

  const onEditSelectedItem= (e, tmp) => {
    // console.log(e, tmp);
    return;
    aTimeout = setTimeout(function(){
      setIsOpen(true);
      setSelTmp(tmp);
    }, 1000);
  }

  const onEditSelectedItem1 = (e, tmp) => {
    if(window.mobileCheck())
      return;
    onEditSelectedItem(e, tmp);
  }

  function afterOpenModal() {
    // references are now sync'd and can be accessed.
    // subtitle.style.color = '#f00';
  }

  function closeModal() {
    setIsOpen(false);
  }

  const onRemoveSelItem = (event) => {    
    console.log(selTmp);
    axios.get(URL_API+"deleteTablesData", {
      params: {
        id: selTmp.items.id, 
        pre_id:selTmp.id,
        sel: se['id'], 
      }
    })
    .then(function (response) {
      if(Array.isArray(response.data)){
        s_setProposerData(response.data);
        window.sessionStorage.setItem('a_proposer', JSON.stringify(response.data));
      }
      setIsOpen(false);
    });
  }

  useEffect(() => {

    session = window.sessionStorage.getItem('sessions'); 
    if(session === null){
      window.location = '/';
    }
    se = JSON.parse(session);
    
    s_setProposerData(JSON.parse(window.sessionStorage.getItem("a_proposer")));
    axios.post(URL_API+"getPreparaAfterListAPI", {
      params: {
        sel: se['id'], 
      }
    })
    .then(function (response) {
    
      if(Array.isArray(response.data)){
        s_setProposerData(response.data);
        window.sessionStorage.setItem('a_proposer', JSON.stringify(response.data));
      }

    }); 
    
    // s_setOpponentData(JSON.parse(window.sessionStorage.getItem("a_opponent")));
    // axios.get(URL_API+"getOpponentAfterListAPI", {
    //   params: {
    //     sel: se['id'], 
    //   }
    // })
    // .then(function (response) {
      
    //   if(response.data != ""){
    //     s_setOpponentData(response.data);
    //     window.sessionStorage.setItem('a_opponent', JSON.stringify(response.data));
    //   }
    // }); 

  }, []);
 

  return (

    <>
      <Modal
        isOpen={modalIsOpen}
        onAfterOpen={afterOpenModal}
        onRequestClose={closeModal}
        style={customStyles}
        contentLabel="Example Modal">
        <div className="row col-12 px-0 mx-0 py-2 justify-content-center align-items-center border-bottom">
          削除
        </div>
        <div className="row col-12 px-0 mx-0 py-4 justify-content-center align-items-center border-bottom">
          本当に削除しますか？
        </div>
        <div className="col-12 px-0 mx-0 d-flex justify-content-between align-items-center">
          <span className="col-6 py-2 px-0 d-flex justify-content-center align-items-center" onClick={(event) => setIsOpen(false)}>キャンセル</span>
          <span className="col-6 py-2 px-0 d-flex justify-content-center align-items-center border-left" onClick={(event) => onRemoveSelItem(event)}>削除</span>
        </div>
      </Modal>
      <div className="content px-0 mb-0 coach-user-content">
        <NotificationAlert ref={notificationAlert} />
        <Row className="px-0 mx-0">          
          <Col className="col-12 px-0">
            <Card className="card-user mb-0">              
              <CardBody>
                <Form>
                  <Row>
                    <CardHeader>
                      <CardTitle tag="h6">トーナメントリスト</CardTitle>                
                    </CardHeader>
                    <Col md="12">                                         
                      {
                        a_proposer?.map((tmp, index) => 

                        <Row className="align-items-center" key={index} style={{borderBottom:'dotted 1px #ccc', padding:'5px'}}  onClick={() => getViewpageUrl(tmp)} val={tmp.id} onTouchStart = {(event) => onEditSelectedItem(event, tmp)} onMouseDown = {(event) => onEditSelectedItem1(event, tmp)}> 
                          <Col className="col-1" style={{color:'rgb(3, 115, 202)', fontSize:'16px', padding:'0px'}}>
                            <img src={tmp.winflag == 1? winImg : loseImg}  width="25px"/>
                          </Col>                        
                          <Col className="col-3" style={{color:'rgb(3, 115, 202)', fontSize:'16px', padding:'0px'}}>
                            <b>{tmp.tournament}</b>
                          </Col>
                          <Col className="col-3" style={{color:'rgb(3, 115, 202)', fontSize:'14px', padding:'0px'}}>
                            {tmp.tourdate}   
                          </Col>
                          <Col className="col-3" style={{color:'rgb(3, 115, 202)', fontSize:'14px', padding:'0px', wordBreak:'break-all'}}>
                          {tmp.opponentgroup} {tmp.opponentname}
                          </Col>
                          <Col className="col-2 text-center" style={{color:'#FF0000', fontSize:'14px', padding:'0px'}}>
                            <b>{tmp.items.win1} - {tmp.items.lose1}</b><br/>
                            <b>{tmp.items.win2} - {tmp.items.lose2}</b><br/>
                            <b>{tmp.items.win3} - {tmp.items.lose3}</b>
                          </Col>
                        </Row>
                        )
                      } 
                    </Col>
                  </Row>
                  {/* <Row>
                    <CardHeader>
                      <CardTitle tag="h6">トーナメントリスト</CardTitle>                
                    </CardHeader>
                    <Col md="12">                                         
                      {
                        a_opponent?.map((tmp, index) => 

                        <Row key={index} style={{borderBottom:'dotted 1px #ccc', padding:'3px'}}  onClick={() => getViewpageUrl(tmp)} val={tmp.id}> 
                          <Col className="col-2" style={{color:'#18258c', fontSize:'16px', paddingRight:'0px'}}>
                            <img src={tmp.winflag == 1? winImg : loseImg}  width="25px"/>
                          </Col>                        
                          <Col className="col-3" style={{color:'#18258c', fontSize:'16px', padding:'0px'}}>
                            <b>{tmp.tournament}</b>
                          </Col>
                          <Col className="col-3" style={{color:'#419617', fontSize:'14px', padding:'0px'}}>
                            {tmp.tourdate}   
                          </Col>
                          <Col className="col-3" style={{color:'#419617', fontSize:'14px', padding:'0px'}}>
                          {tmp.proposergroup} {tmp.proposername}
                          </Col>
                          <Col className="col-1" style={{color:'#FF0000', fontSize:'14px', padding:'0px'}}>
                            {tmp.mark}
                          </Col>
                        </Row>
                        )
                      } 
                    </Col>
                  </Row>                                  */}
                </Form>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </div>
    </>
  );
}

export default Tables;
